import { render } from "./variablesLarga.vue?vue&type=template&id=c5c71528"
import script from "./variablesLarga.vue?vue&type=script&lang=js"
export * from "./variablesLarga.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__